import { inject } from '@angular/core';
import { SchemaFormsService } from '@apexdesigner/schema-forms';

export function registerSchemaFormFields(): void {
  const schemaForms = inject(SchemaFormsService);

  // Field registrations (library order — later overrides earlier)
  schemaForms.registerField('select-role', () =>
    import('@components/select-role-field/select-role-field.component').then(
      (m) => m.SelectRoleFieldComponent,
    ),
  );
  schemaForms.registerField('select-role-name', () =>
    import('@components/select-role-name-field/select-role-name-field.component').then(
      (m) => m.SelectRoleNameFieldComponent,
    ),
  );
  schemaForms.registerField('select-user', () =>
    import('@components/select-user-field/select-user-field.component').then(
      (m) => m.SelectUserFieldComponent,
    ),
  );
  schemaForms.registerField('currency', () =>
    import('@components/sf-currency-field/sf-currency-field.component').then(
      (m) => m.SfCurrencyFieldComponent,
    ),
  );
  schemaForms.registerField('decimal', () =>
    import('@components/sf-decimal-field/sf-decimal-field.component').then(
      (m) => m.SfDecimalFieldComponent,
    ),
  );
  schemaForms.registerField('integer', () =>
    import('@components/sf-integer-field/sf-integer-field.component').then(
      (m) => m.SfIntegerFieldComponent,
    ),
  );
  schemaForms.registerField('percentage', () =>
    import('@components/sf-percentage-field/sf-percentage-field.component').then(
      (m) => m.SfPercentageFieldComponent,
    ),
  );
  schemaForms.registerField('reference', () =>
    import('@components/sf-reference-field/sf-reference-field.component').then(
      (m) => m.SfReferenceFieldComponent,
    ),
  );
  schemaForms.registerField('timezone', () =>
    import('@components/sf-timezone-field/sf-timezone-field.component').then(
      (m) => m.SfTimezoneFieldComponent,
    ),
  );
}
